import { useState, useEffect, useMemo } from 'react';
import CloseIcon from '../../../assets/icons/close.svg?react';
import DateTimeInput from '../../../components/DateTimeInput/DateTimeInput';
import { useCreateAiLearning } from '../../../hooks/queries/aiQueries';
import { positiveNumberInputFormatter } from '../../../utils/utils';
import dayjs from 'dayjs';

const AiLearningDemandReRequestModal = ({onClose, onSuccess, target}) => {

  const createAiLearning = useCreateAiLearning();

  const [formDataForRe, setFormDataForRe] = useState({
    "selectedModelName": target?.ModuleName || null,
    "aiModelType": target?.AiModelType || null,
    "selectedModelVersion": target?.Version || null,
    "interationCount": null,
    "startDate": null,
    "endDate": null,
    "isNewModel": false,
    "originAiAlgorithm": target?.OriginAiAlgorithm || null,
    "demandPredictionAiModelName": null,
    "demandPredictionAiModelVersion": null
  });


  const handleFormDataForReChange = (key, value) => {
    setFormDataForRe({ ...formDataForRe, [key]: value });
  };

  const canComplete = useMemo(() => {
    if (!formDataForRe.interationCount) return false;
    if (parseInt(formDataForRe.interationCount) <= 0) return false;
    if (!formDataForRe.startDate) return false;
    if (!formDataForRe.endDate) return false;
    return true;
  }, [formDataForRe]);


  // API payload 생성 함수
  const buildApiPayload = () => {
    return {
      selectedModelName: formDataForRe.selectedModelName || '',
      aiModelType: 'ChargingDemandPrediction',
      selectedModelVersion: formDataForRe.selectedModelVersion || '',
      interationCount: parseInt(formDataForRe.interationCount),
      startDate: formDataForRe.startDate ? dayjs(formDataForRe.startDate).toISOString() : '',
      endDate: formDataForRe.endDate ? dayjs(formDataForRe.endDate).toISOString() : '',
      isNewModel: false,
      originAiAlgorithm: formDataForRe.originAiAlgorithm || '',
      demandPredictionAiModelName: formDataForRe.demandPredictionAiModelName || '',
      demandPredictionAiModelVersion: formDataForRe.demandPredictionAiModelVersion || '',
    };
  };

  // 완료 버튼 클릭 핸들러
  const handleComplete = async () => {
    if (!canComplete) return;

    const payload = buildApiPayload();
    if (!payload) {
      alert('잘못된 요청 타입입니다.');
      return;
    }

    try {
      await createAiLearning.mutateAsync(payload);
      if (onSuccess) {
        onSuccess();
      }
      handleClose();
    } catch (error) {
      console.error('AI 학습 요청 실패:', error);
      alert(`AI 학습 요청 등록에 실패했습니다:`);
    }
  };

  const handleClose = () => {
    setFormDataForRe({
      "selectedModelName": null,
      "aiModelType": null,
      "selectedModelVersion": null,
      "interationCount": null,
      "startDate": null,
      "endDate": null,
      "isNewModel": false,
      "originAiAlgorithm": null,
      "demandPredictionAiModelName": null,
      "demandPredictionAiModelVersion": null
    });
    createAiLearning.reset();
    onClose();
  };

  const aiModelTypeConvert = (aiModelType) => {
    switch (aiModelType) {
      case 'ChargingDemandPrediction': return '충전량 예측 모델';
      case 'CblPrediction': return 'CBL 예측 모델';
      default: return aiModelType;
    }
  }

  return (
    <div className="modal-background">
      <div className="modal-container overflow-visible learning-demand-re-request-modal">
        <div className="modal-header">
          <h3>충전량 예측 모듈 재학습 요청</h3>
          <button className="close-btn" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <div className="modal-content flex flex-col gap-10 p-10">

          <div className='flex flex-col gap-2'>
            <table className='gray-table'>
              <tr>
                <th>AI 모델 타입</th>
                <td>{aiModelTypeConvert(target?.AiModelType)}</td>
              </tr>
              <tr>
                <th>모듈명</th>
                <td>{target?.ModuleName}</td>
              </tr>
              <tr>
                <th>버전</th>
                <td>{target?.Version}</td>
              </tr>
              <tr>
                <th>Base알고리즘</th>
                <td>{target?.OriginAiAlgorithm}</td>
              </tr>
              <tr>
                <th>생성일시</th>
                <td>{dayjs(target?.CreatedDate).format('YYYY-MM-DD HH:mm:ss')}</td>
              </tr>
            </table>
          </div>


          <div className='grid grid-cols-3 gap-10 align-center'>
            <div className='flex flex-col gap-2'>
              <p className='text-b2-400 text-gray-800'>학습 횟수</p>
              <input type="text" className='input-primary' placeholder='학습 횟수를 입력하세요 (숫자)' onInput={(e) => positiveNumberInputFormatter(e)} value={formDataForRe.interationCount} onChange={(e) => handleFormDataForReChange('interationCount', e.target.value)} />
            </div>
            <div className='flex flex-col gap-2'>
              <p className='text-b2-400 text-gray-800'>학습 데이터 시작 일시</p>
              <DateTimeInput
                type="date"
                value={formDataForRe.startDate}
                onChange={(value) => handleFormDataForReChange('startDate', value)}
                placeholder="시작일을 선택하세요"
                max={formDataForRe.endDate}
              />
            </div>
            <div className='flex flex-col gap-2'>
              <p className='text-b2-400 text-gray-800'>학습 데이터 종료 일시</p>
              <DateTimeInput
                type="date"
                value={formDataForRe.endDate}
                onChange={(value) => handleFormDataForReChange('endDate', value)}
                placeholder="종료일을 선택하세요"
                min={formDataForRe.startDate}
              />
            </div>
          </div>
          <div className='flex justify-end'>
            <button className='btn btn-primary big-btn' onClick={handleComplete} disabled={createAiLearning.isPending || !canComplete}>
              {createAiLearning.isPending ? '재학습 요청 중...' : '재학습 요청'}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AiLearningDemandReRequestModal